export default __webpack_public_path__ + "static/media/rgs_main.2ce0599a.jpg";